import { Icon, Table } from "@ttc3k/trekker";
import { Trash } from "iconoir-react";
import { formatPrice } from "shared/utils";
import { styled } from "styled-system/jsx";
import { useCartContext } from "widgets/booker/contexts";

type PromoCodeSummaryProps = {
  label: string;
  total: number;
};

export const PromoCodeSummary = ({ label, total }: PromoCodeSummaryProps) => {
  const { updatePromoCode } = useCartContext();
  return (
    <Table.Row>
      <Table.Header paddingRight={"150"} lineClamp={2}>
        {label}
      </Table.Header>
      <Table.Cell>
        <styled.span display="inline-flex" alignItems="center">
          <styled.span whiteSpace="nowrap">-${formatPrice(total)}</styled.span>
          <styled.button
            cursor={"pointer"}
            pl="50"
            transitionDuration={"normal"}
            transitionProperty={"color"}
            transitionTimingFunction={"default"}
            _hover={{ color: "text.mid" }}
            onClick={() => updatePromoCode("")}
          >
            <Icon Element={Trash} />
          </styled.button>
        </styled.span>
      </Table.Cell>
    </Table.Row>
  );
};
